var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('Card',{style:({
    visibility: _vm.withCard ? 'visible' : 'hidden',
  })},[_c('b-tabs',{class:_vm.tabClasses,attrs:{"content-class":"stepper-tabs mt-3","justified":""}},[_vm._t("default")],2)],1)}
var staticRenderFns = []

export { render, staticRenderFns }